import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnquiriesDashboardService {

  constructor(private ws: PostmethodService) { }

  getLeadSource(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardLeadSourceFilter");
  }

  getGeography(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardgeogrphicalFilter");
  }

  getStatus(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardCombineFilter");
  }

  getUser(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardUserFilter");
  }

  getProduct(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardProductFilter");
  }

  getZoneCounts(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardCount");
  }

  getStageCounts(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardStage");
  }

  getContactedounts(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/contactedTcManagerLeadCount");
  }

  getGeographyChartCounts(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardGeographyCount");
  }

  getLeadPriorityCount(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardDmsStageCount");
  }

  getDealersAndOutlets(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardParentOutletFilter");
  }

  getParentDealerChartCount(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/DashboardParentDealerCount");
  }

  getCallWebEnq(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/callWebEnquires");
  }

  getRegionalMgrs(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/regionalManagerFilter");
  }

  getAreaMgrs(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/areaManagerFilter");
  }

  getTotalEnq(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardTestRideCount");
  }

   getTotalRetailed(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardTotalRetailedCount");
  }
}
